module.exports = __webpack_public_path__ + "img/img-contact-2.32ab2255.jpg";